import React, { useState } from "react";
import ellipse from "../../assets/images/red-required-Asterisk.svg";
import group from "../../assets/images/earning-invoice-group.svg";
import './add-new-invoice-upload-model.scss'
import { Row, Button, Input, Select, DatePicker } from "antd";
import leftArrow from "../../assets/images/earning-invoice-left-arrow.svg";


const InvoiceUploadModel = () => {
    const [formData, setFormData] = useState({
        invoiceId: '',
        tripStartDate: null,
        tripEndDate: null,
        fromValue: null,
        toValue: null,
        uploadedInvoice: null,
    });

    const handleInputChange = (e, field) => {
        const value = e?.target?.value || e;
        setFormData((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const handleApply = () => {
        console.log('Filters Applied:', formData);
    };

    const handleReset = () => {
        setFormData({
            invoiceId: '',
            tripStartDate: null,
            tripEndDate: null,
            fromValue: null,
            toValue: null,
            uploadedInvoice: null,
        });
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            setFormData((prevState) => ({
                ...prevState,
                uploadedInvoice: file,
            }));
        } else {
            console.log('Please upload a valid PDF file.');
        }
    };
    const handleDateChange = (date, field) => {
        setFormData((prevState) => ({
            ...prevState,
            [field]: date ? date.toDate() : null,
        }));
    };

    return (
        <div className="invoice-upload-model-wrapper">
            <Row className='invoice-btn-row'>
                <div className="invoice-upload"><img src={leftArrow} alt="icon" />Add New Invoice</div>
            </Row>
            <Row className="upload-row">
                <label className="input-label">Invoice ID <img src={ellipse} alt="asterisk" /></label>
                <Input
                    value={formData.invoiceId}
                    onChange={(e) => handleInputChange(e, 'invoiceId')}
                    placeholder="Enter Invoice ID here"
                    className="invoice-input-field"
                />
            </Row>
            <Row className="invoice-upload-row">
                <label className="invoice-document">Invoice Document</label>
                <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleFileUpload}
                    id="invoice-upload-input"
                    style={{ display: 'none' }}
                />
                <button
                    className="invoice-upload-button"
                    onClick={() => document.getElementById('invoice-upload-input').click()}
                >
                    <img src={group} alt="upload icon" />Upload Invoice
                </button>
            </Row>

            <Row className="filter-card-wrapper">
                <div className="filter-card-title">Apply filters to start selecting Order Ids</div>
                <div className="date-picker-wrapper">
                    <div className="date-pick-div">
                        <span className="input-label">Trip Start date</span>
                        <DatePicker
                            label="Trip Start date"
                            className="date-picker"
                            placeholder="Select Trip Start Date"
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateChange(date, 'tripStartDate')}
                        />
                    </div>
                    <div className="date-pick-div">
                        <span className="input-label">Trip End date</span>
                        <DatePicker
                            label="Trip End date"
                            className="date-picker"
                            placeholder="Select Trip End Date"
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateChange(date, 'tripEndDate')}
                        />
                    </div>
                </div>

                <div className="from-to-wrapper">
                    <div className="from-to-div">
                        <span className="input-label">From</span>
                        <Select
                            className="from-to-select"
                            value={formData.fromValue}
                            onChange={(value) => handleInputChange(value, 'fromValue')}
                            placeholder="Select"
                            options={[
                                { value: 'test', label: 'test' },
                                { value: 'test2', label: 'test2' },
                                { value: 'test3', label: 'test3' },
                                { value: 'test4', label: 'test4', disabled: true },
                            ]}
                        />
                    </div>
                    <div className="from-to-div">
                        <span className="input-label">To</span>
                        <Select
                            value={formData.toValue}
                            onChange={(value) => handleInputChange(value, 'toValue')}
                            className="from-to-select"
                            placeholder="Select"
                            options={[
                                { value: 'test', label: 'test' },
                                { value: 'test2', label: 'test2' },
                                { value: 'test3', label: 'test3' },
                                { value: 'test4', label: 'test4', disabled: true },
                            ]}
                        />
                    </div>
                </div>

                <div className="btn-div">
                    <Button className="reset-btn" onClick={handleReset}>Reset</Button>
                    <Button className="apply-btn" onClick={handleApply}>Apply</Button>
                </div>
            </Row>
        </div>
    );
};

export default InvoiceUploadModel;
